import { useAuth } from "~/components/react-auth";
import { ATOMIC_ROLE_PREFIX } from "~/constants";
import { type Tenant } from "~/lib/auth-service";

export const getAvailableTenants = (teams: Tenant[] | undefined): Tenant[] => {
  if (!teams) return [];
  return teams.filter((team) =>
    team.roles?.some((role) => role.startsWith(ATOMIC_ROLE_PREFIX)),
  );
};

/**
 * Hook to get available tenants from user's teams
 * - Extracts teams with Atomic: prefixed roles from user teams
 * - Returns filtered list of tenants
 */
export const useAvailableTenants = (): Tenant[] => {
  const auth = useAuth();
  const tenants = getAvailableTenants(auth?.user?.teams);

  return tenants;
};
